import { Spin } from 'antd/es'
import { Flex } from 'antd/es'
import React from 'react'

const Loader = () => {
    return (
        <div>
            <Flex fullscreen justify="center" style={{ alignItems: "center", height: "100vh" }}>
                <Spin size="large" />
            </Flex>
        </div>
    )
}

export default Loader